export const setDocumentTitle = (title: string, url: string) => {
    if(!url.includes("launchtype=tab")){
        document.title = title ?  "CDK Unify - ".concat(title) : "CDK Unify" ;
    }
}